/* ==========================================================================
   AKKERFASSI — Comportements repris du thème Prestige
   --------------------------------------------------------------------------
   1. En-tête transparent au-dessus du visuel d'ouverture, puis retour à
      l'en-tête plein dès que la page défile.
   2. Bouton "section suivante" du hero.
   3. Comparateur avant / après.
   4. Pop-up newsletter (délai, une seule fois, page d'accueil seulement).
   5. Défilement automatique du visuel d'ouverture.
   6. Passerelle panier : fait comprendre à Dawn les événements panier que
      ton sélecteur de bundle envoie (voir le commentaire détaillé plus bas).
   7. Montant du panier affiché dans le bouton Checkout, comme Prestige.
      (Les styles du tiroir sont dans akf-prestige.css, section 13.)
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- 1 & 2 */

  function initTransparentHeader() {
    var hero = document.querySelector('[data-akf-transparent-header]');
    if (!hero) return;

    var headerSection = document.querySelector('.section-header');
    if (!headerSection) return;

    // Le visuel ne prend l'en-tête transparent que s'il ouvre vraiment la page.
    var main = document.getElementById('MainContent');
    var firstSection = main && main.querySelector('.shopify-section');
    if (!firstSection || !firstSection.contains(hero)) return;

    document.body.classList.add('akf-transparent-header');
    firstSection.classList.add('akf-hero-offset');

    var color = hero.getAttribute('data-akf-transparent-header');
    if (color) {
      document.body.style.setProperty('--akf-transparent-header-text', color);
    }

    // Le visuel remonte exactement de la hauteur de l'en-tête.
    function setOffset() {
      document.body.style.setProperty(
        '--akf-header-offset',
        headerSection.offsetHeight + 'px'
      );
    }

    setOffset();
    window.addEventListener('resize', setOffset);
    if (window.ResizeObserver) {
      new ResizeObserver(setOffset).observe(headerSection);
    }

    // Sentinelle : dès qu'elle sort du champ, l'en-tête reprend son fond.
    var sentinel = document.createElement('div');
    sentinel.style.cssText =
      'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
    document.body.prepend(sentinel);

    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      headerSection.classList.toggle('akf-header-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  function initScrollDown() {
    document.querySelectorAll('[data-akf-scroll-down]').forEach(function (button) {
      button.addEventListener('click', function () {
        var section = button.closest('.shopify-section');
        var next = section && section.nextElementSibling;
        if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* -------------------------------------------------------------------- 3 */

  function initBeforeAfter() {
    document.querySelectorAll('[data-akf-ba]').forEach(function (root) {
      var range = root.querySelector('[data-akf-ba-range]');
      var layer = root.querySelector('[data-akf-ba-layer]');
      var handle = root.querySelector('[data-akf-ba-handle]');
      if (!range || !layer || !handle) return;

      var vertical = root.classList.contains('akf-ba--vertical');

      // Le calque « avant » occupe la partie gauche (ou haute) du cadre :
      // on masque donc tout ce qui dépasse la position du curseur.
      function apply(value) {
        var rest = 100 - value;
        if (vertical) {
          layer.style.clipPath = 'inset(0 0 ' + rest + '% 0)';
          handle.style.top = value + '%';
        } else {
          layer.style.clipPath = 'inset(0 ' + rest + '% 0 0)';
          handle.style.left = value + '%';
        }
      }

      apply(range.value);
      range.addEventListener('input', function () {
        apply(range.value);
      });
    });
  }

  /* -------------------------------------------------------------------- 4 */

  function initNewsletterPopup() {
    var popup = document.querySelector('[data-akf-popup]');
    if (!popup) return;

    var key = 'akf-newsletter-popup';
    var once = popup.getAttribute('data-akf-popup-once') === 'true';
    var delay = parseInt(popup.getAttribute('data-akf-popup-delay'), 10) || 0;

    function seen() {
      try {
        return localStorage.getItem(key) === '1';
      } catch (e) {
        return false;
      }
    }

    function remember() {
      try {
        localStorage.setItem(key, '1');
      } catch (e) {
        /* navigation privée : on laisse tomber sans casser la page */
      }
    }

    function close() {
      popup.classList.remove('is-open');
      if (once) remember();
    }

    popup.querySelectorAll('[data-akf-popup-close]').forEach(function (element) {
      element.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    if (once && seen()) return;
    if (window.Shopify && window.Shopify.designMode) return;

    window.setTimeout(function () {
      popup.classList.add('is-open');
    }, delay * 1000);
  }

  /* -------------------------------------------------------------------- 5 */

  function initHeroAutoplay() {
    document.querySelectorAll('[data-akf-hero]').forEach(function (hero) {
      var slides = hero.querySelectorAll('[data-akf-hero-slide]');
      if (slides.length < 2) return;
      if (hero.getAttribute('data-akf-hero-autoplay') !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var speed = (parseInt(hero.getAttribute('data-akf-hero-speed'), 10) || 5) * 1000;
      var index = 0;

      window.setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, speed);
    });
  }

  /* -------------------------------------------------------------------- 6 */
  /*
     Passerelle panier.

     Ton sélecteur de bundle ajoute au panier avec un fetch direct vers
     /cart/add.js, puis prévient le thème avec les événements de Prestige
     (cart:refresh, cart:change, cart:updated). Dawn ne connaît pas ces
     événements : il ne rafraîchit donc ni le contenu du tiroir ni la pastille
     du panier, et il garde la classe « is-empty » sur <cart-drawer> — classe
     dont le CSS masque tout le contenu. Résultat : les articles SONT bien
     ajoutés côté Shopify, mais le tiroir s'ouvre vide.

     On écoute donc ces trois événements et on exécute ce que Dawn fait
     normalement après un ajout : retirer « is-empty », recharger les sections
     « cart-drawer » et « cart-icon-bubble », puis les injecter via la méthode
     native renderContents() du thème, qui ouvre le tiroir au passage.

     Ton code n'est pas modifié : c'est Dawn qui apprend à répondre.
  */

  var cartBridgeBound = false;

  function initCartBridge() {
    // Ce fichier est chargé avant cart-drawer.js : l'élément <cart-drawer>
    // n'est pas encore « défini » à cet instant. On se contente donc de poser
    // les écouteurs, et on va chercher le tiroir au moment du clic, quand le
    // thème est entièrement chargé.
    if (cartBridgeBound) return;
    cartBridgeBound = true;

    var busy = false;

    function root() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    }

    function refresh() {
      if (busy) return;

      var drawer = document.querySelector('cart-drawer');

      // Pas de tiroir sur ce thème, ou méthode absente : la page panier
      // reste une issue correcte, l'ajout a bien eu lieu côté Shopify.
      if (!drawer || typeof drawer.renderContents !== 'function') {
        window.location.href = root() + 'cart';
        return;
      }

      busy = true;

      // Tout de suite, pour éviter que le tiroir s'ouvre sur l'état « vide ».
      drawer.classList.remove('is-empty');

      fetch(root() + '?sections=cart-drawer,cart-icon-bubble', {
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('sections');
          return response.json();
        })
        .then(function (sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ sections: sections });
        })
        .catch(function () {
          // Dernier recours : la page panier, où le contenu est forcément juste.
          window.location.href = root() + 'cart';
        })
        .then(function () {
          busy = false;
        });
    }

    ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (name) {
      document.documentElement.addEventListener(name, refresh);
    });
  }

  /* -------------------------------------------------------------------- 7 */
  /*
     Montant dans le bouton Checkout.

     Prestige affichait le total dans le bouton (« CHECKOUT — 44,86 € »)
     plutôt que sur une ligne « Estimated total » séparée : c'est le réglage
     show_price_in_checkout_button, activé sur ta boutique. La ligne de total
     de Dawn est masquée en CSS mais reste dans le DOM : on y lit le montant
     et on le recopie dans le bouton.

     Le tiroir est ré-rendu par le serveur à chaque changement de panier, donc
     on réapplique à chaque fois que son contenu bouge.
  */

  function paintCheckoutPrice() {
    var button = document.getElementById('CartDrawer-Checkout');
    var total = document.querySelector('.cart-drawer .totals__total-value');
    if (!button || !total) return;

    // Dawn écrit « 44,86 € EUR » ; le code ISO était masqué chez Prestige
    // (réglage currency_code_enabled décoché), on le retire.
    var amount = total.textContent.trim().replace(/\s+[A-Z]{3}$/, '');
    if (!amount) return;

    var slot = button.querySelector('.akf-checkout-price');
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'akf-checkout-price';
      button.appendChild(slot);
    }
    if (slot.textContent !== amount) slot.textContent = amount;
  }

  function initCheckoutPrice() {
    var container = document.getElementById('CartDrawer');
    if (!container) return;

    paintCheckoutPrice();

    if (!window.MutationObserver) return;
    new MutationObserver(paintCheckoutPrice).observe(container, {
      childList: true,
      subtree: true,
    });
  }

  /* ---------------------------------------------------------------- init  */

  function init() {
    initTransparentHeader();
    initScrollDown();
    initBeforeAfter();
    initNewsletterPopup();
    initHeroAutoplay();
    initCartBridge();
    initCheckoutPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // L'éditeur de thème recharge les sections sans recharger la page.
  document.addEventListener('shopify:section:load', function () {
    initScrollDown();
    initBeforeAfter();
    initNewsletterPopup();
    initCartBridge();
  });
})();
